import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { FiMoreHorizontal, FiSettings } from "react-icons/fi";
import * as timesActions from "actions/timesActions";
import Layout from "components/Layout";
import { widgetsService } from "services";
import { isAdmin, isSupervisor } from "utils/utils";
import { withTranslation } from "react-i18next";
import Modal from "components/Modal";
import {
	getWidgetComponent,
	sortByPosition,
} from "components/WidgetTemplates/utils";
import Loading from "components/Loading";
import { default as WithoutTime } from "components/Dashboard/Dashboard_WithoutTime";
import { default as TimeRegistrationAlerts } from "components/Dashboard/Dashboard_TimeAlerts";

class Dashboard extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.state = {
			employee_widgets: [],
			hasSuperPowers: isAdmin() || isSupervisor(),
		};
	}

	async componentDidMount() {
		this.props.getDefaultTimeType();

		const employee_id = this.props.user.id;
		this.setState({
			loading: true,
		});

		const employee_widgets = await widgetsService.getByEmployeeId(employee_id);

		const employee_widgets_sorted = employee_widgets
			.filter((widget) => widget.enabled !== false && widget.enabled !== 0)
			.slice()
			.sort(sortByPosition)
			.map((w) => ({ ...w }));

		this.setState({
			employee_widgets: employee_widgets_sorted,
			loading: false,
		});
	}

	getWidgets = () =>
		this.state.employee_widgets.map((widget) =>
			getWidgetComponent(widget, this.state.hasSuperPowers)
		);
	getContent = () => {
		if (this.state.loading && !this.state.employee_widgets) {
			return <Loading />;
		}

		if (!this.state.employee_widgets) {
			return this.props.t("dashboard.errorWidgets");
		}

		return (
			<>
				{this.getWidgets()}

				{this.state.hasSuperPowers && (
					<>
						<div className="widget_2x1">
							<article className="card card-without-time">
								<div className="card-top">
									<h2>{this.props.t("dashboard.pendingTimesToday")}</h2>
								</div>
								<div className="card-content">
									<WithoutTime />
								</div>
							</article>
						</div>

						<div className="widget_2x1">
							<article className="card card-time-alerts">
								<TimeRegistrationAlerts />
							</article>
						</div>
					</>
				)}
			</>
		);
	};

	render() {
		return (
			<>
				<Layout className="page-dashboard">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t("dashboard.title")}</h1>
						</div>

						<div className="heading-actions">
							{isAdmin() && (
								<Dropdown>
									<Dropdown.Toggle variant="action">
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											onClick={() =>
												this.props.history.push("/widget-templates")
											}
										>
											<FiSettings /> {this.props.t("dashboard.configureWidgets")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							)}
						</div>
					</div>

					<section className="list-widgets">{this.getContent()}</section>
				</Layout>
				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.timesReducer,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getDefaultTimeType: () => dispatch(timesActions.getDefaultTimeType()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Dashboard));
